const increment = () => {
  return { type: "INCREMENT" };
};

const mobile = () => {
  return { type: "MOBILE" };
};
const fullScreen = () => {
  return { type: "FULL" };
};

export { increment, mobile, fullScreen };
